<template>
    <q-btn
        v-if="errors"
        color="red"
        icon="error"
        label="Errors"
        glossy
        dense
    >
        <q-badge color="red" floating>{{errors.length}}</q-badge>
        <q-menu>
            <div class="row no-wrap q-pa-md">
            <q-list>
                <div v-for="(gqlError,i) in errors" :key="i">
                <q-item>
                    <q-item-section avatar top>
                    <q-icon name="error" color="red" />
                    </q-item-section>
                    <q-item-section>
                    <q-item-label>{{gqlError.message}}</q-item-label>
                    <q-item-label caption lines="2">
                        <span class="text-weight-medium">Locations</span> :
                        {{JSON.stringify(gqlError.locations)}}
                    </q-item-label>
                    <q-item-label caption lines="2">
                        <span class="text-weight-medium">Path</span> :
                        {{JSON.stringify(gqlError.path)}}
                    </q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                    <q-item-label caption>
                        {{gqlError.extensions.code}}
                    </q-item-label>
                    </q-item-section>

                </q-item>
                <q-separator spaced inset v-if="i+1 < errors.length"/>
                </div>
            </q-list>
            </div>
        </q-menu>
    </q-btn>
</template>

<script>
export default {
  props: {
    errors: Array
  }
};
</script>
